import { Component, Input, OnDestroy, ChangeDetectionStrategy } from '@angular/core';
import { Subject } from 'rxjs';
import { Step, Stepper, StepperState } from './stepper';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class StepperComponent implements OnDestroy {
  StepperState = StepperState;
  stepper: Stepper;
  private readonly destroy$ = new Subject<void>();

  @Input() set steps(steps: Step[]) {
    this.stepper = {
      steps,
      state: this.findStepperState(steps),
    };
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private findStepperState(steps: Step[]) {
    const isComplete = steps.every((step) => step.state === StepperState.DONE);
    if (isComplete) {
      return StepperState.DONE;
    }

    const notStarted = steps.every((step) => step.state === StepperState.NOT_STARTED);
    return notStarted ? StepperState.NOT_STARTED : StepperState.IN_PROGRESS;
  }
}
